<template>
  <div class="rollingCard">
    <div slot="header" class="header">
      <span class="hL">{{list.name}}</span>
      <span class="hR" style="cursor:pointer" @click='skip(list)'>更多>></span>
    </div>
    <div @click="negotiation">
      <vueSeamless :data="list.list" class="seamless-warp" :class-option="seamlessScrollOption">
        <ul class="warpContent">
            <li v-for="(item,index) in list.list" :key="index">
              <div class="left">
                <p class="xinxi">
                  <span class="portrait"><img v-lazy="item.img_url"/></span>
                  <span class="corpname">{{item.corpname}}</span>
                  <span class="duties">{{item.duties}}</span>
                </p>
                <p id="content" class="conten" :aname="item.id">{{item.content}}</p>
              </div>
              <div class="right">
                <p><span><i class="el-icon-view" style="padding-right:4px"></i> 
                </span><span>{{item.click}}</span></p>
                <p><button :name="item.id">洽谈</button></p>
              </div>
          </li>
        </ul>
      </vueSeamless>
    </div>
  </div>
</template>

<script>
import vueSeamless from 'vue-seamless-scroll'
export default {
  components:{
    vueSeamless
  },
  props: {
    list:Object,
  },
  data () {
    return {
      show:false
    }
  },
  methods:{
    
    negotiation(e){//洽谈
      if (e.target.localName=="button") {
        let key = this.list.key
        sessionStorage.setItem('negotiation',JSON.stringify({id:e.target.name,key}))
        this.$router.push("/supply")
      }
      if (e.target.id=='content') {
        let key = this.list.key
        sessionStorage.setItem('negotiation',JSON.stringify({id:e.target.attributes.aname.nodeValue,key}))
        this.$router.push("/supply")
      }
    },
    skip(list){
      sessionStorage.setItem('selected',JSON.stringify(list.key));
      this.$router.push('/supply')
    }
  },
  computed: {
    seamlessScrollOption() {
      return {
        step: 0.5
      }
    }
  }

}
</script>

<style scoped>
  /* .show{
    display: block;
  } */
  .rollingCard{
    width: 48%;
    border: 1px solid #cccccc;
    background-color: white;
  }
  .header{
    width: 100%;
    height: 38px;
    padding: 5px 20px;
    background-color: #eeeeee;
  }
  .hL{
    font-size: 18px;
    font-weight: 600;
    color: #008baf;
  }
  .hR{
    float: right;
    line-height: 28px;
  }
  .seamless-warp {
    margin: 20px;
    height: 560px;
    overflow: hidden;
  }
  .seamless-warp li{
    padding: 15px 0;
    line-height: 28px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px dashed #c9c9c9;
    display: flex;
  }
  .left{
    width: 76%;
    margin-right: 4%;
    /* background-color: wheat; */
  }
  .left .conten{
    text-indent: 1em;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
  }
  .xinxi{
    /* padding: 4px 0; */
    margin-bottom: 10px;
    vertical-align: bottom;
    color: #008baf;
  }
   .left span{
    vertical-align: middle;
    /* line-height: 40px; */
    margin-right: 8px;
    font-size: 14px;
  }
  .portrait{
    display: inline-block;
    width: 32px;
    border-radius: 50%;
    overflow: hidden;
    /* line-height: 1; */
  }
 
  .portrait img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: middle;
  }
  

  .right{
    width: 20%;
    /* background-color: pink; */
    text-align: center;
    line-height: 40px;
  }
  .right span{
    font-size: 12px;
  }
  .right i{
    font-size: 16px;
    vertical-align: middle;
  }
  .right button{
    /* float: right; */
    background-color: #008baf;
    padding: 0 20px 0 30px;
    border-radius: 15px;
    height: 30px;
    color: white;
    border: none;
    font-size: 14px;
    outline: none;
    transition: all .5s;
    cursor: pointer;
    letter-spacing: 10px;
  }
  .right button:hover{
    background-color: #f08300;
  } 




  /* .pR{
    float: right;
  }
  .p1>.pL{
    font-size: 16px;
  }
  .p1>span,
  .p2>span{
    display: inline-block;
    max-width: 75%;
    margin-top: 4px;
    line-height: 20px;
    font-size: 14px;
  }
  .p2 button{
    float: right;
    background-color: #008baf;
    padding: 0 20px 0 30px;
    border-radius: 15px;
    height: 30px;
    color: white;
    border: none;
    font-size: 14px;
    outline: none;
    transition: all .5s;
    cursor: pointer;
    letter-spacing: 10px;
  }
  .p2 button:hover{
    background-color: #f08300;
  } */
 @media (min-width: 768px) and (max-width: 992px) {
    .right button{
      padding: 0 5px 0 10px;
    }   
  }

</style>